<template>
    <LabelProductImage :label="t('catalogue.lab_grown')" />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import LabelProductImage from './LabelProductImage.vue'

const { t } = useI18n()
</script>
